import React, { useState, useEffect, useCallback, useRef } from "react";
import HeaderUserIcon from './HeaderUserIcon';
import HeaderUserMenu from './HeaderUserMenu';
import HeaderCartButton from './HeaderCartButton';
import HeaderNotifications from './HeaderNotifications';
import HeaderNavBar from './HeaderNavBar';
import { setActiveMobileMenu } from 'state/actions';
import { useSelector, useDispatch } from "react-redux";

const MOBILE_BREAKPOINT = 768;

const Burger = ({ burgerActive, onClick }) => (
    <div
        className={`burger_menu d-inline-block ml-sm-12 ${burgerActive ? 'isActive' : ''}`}
        onClick={onClick}
    >
        <div className="line-1" />
        <div className="line-2" />
        <div className="line-3" />
    </div>
);

const Headers = ({
    isMobile,
    pzMenu,
    setPzMenu,
    setDropdown
}) => {

    const handleUserClick = () => {
        if (isMobile) setDropdown(false);
        setPzMenu(prev => (prev > 0 ? 0 : 1));
    };

    return (
        <>
            <button
                className={`logato_zone-user ${isMobile ? 'text-null' : ''}`}
                data-test-id={isMobile ? "mk-user-btn-m" : "mk-user-btn-d"}
                onClick={handleUserClick}
            >
                <HeaderUserIcon type={isMobile ? "hpz" : "hmpz"} />
            </button>

            <HeaderUserMenu
                mobile={isMobile}
                pzMenu={pzMenu}
                setPzMenu={setPzMenu}
            />

            <HeaderCartButton />
            <HeaderNotifications />
        </>
    );
};

const GlobHeaders = ({
    isMobile,
    auth,
    pzMenu,
    setPzMenu,
    setDropdown,
    burgerActive,
    handleBurgerClick
}) => (
    <>
        {!isMobile && <HeaderNavBar />}

        {auth && (
            isMobile
                ? (
                    <Headers
                        isMobile={isMobile}
                        pzMenu={pzMenu}
                        setPzMenu={setPzMenu}
                        setDropdown={setDropdown}
                    />
                )
                : (
                    <div className="logato_zone d-flex ml-4">
                        <Headers
                            isMobile={isMobile}
                            pzMenu={pzMenu}
                            setPzMenu={setPzMenu}
                            setDropdown={setDropdown}
                        />
                    </div>
                )
        )}

        {isMobile && (
            <Burger
                burgerActive={burgerActive}
                onClick={handleBurgerClick}
            />
        )}
    </>
);


const HeaderAccountMenu = () => {


    const dispatch = useDispatch();
    const menuRef = useRef(null);
    const mobHeaderRef = useRef(null);
    const mobileMenu = useSelector(state => state.mobile_menu);
    const auth = useSelector(state => state.auth);
    const [pzMenu, setPzMenu] = useState(0)
    const [isMobile, setIsMobile] = useState(false);

    /* ---------------- Resize ---------------- */

    useEffect(() => {
        if (typeof window === "undefined") return;

        const media = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

        setIsMobile(media.matches);

        const handleResize = (e) => setIsMobile(e.matches);

        media.addEventListener("change", handleResize);
        return () => media.removeEventListener("change", handleResize);
    }, []);

    const setDropdown = useCallback(
        (status) => {
            dispatch(setActiveMobileMenu(status));
        },
        [dispatch]
    );

    useEffect(() => {
        if (!isMobile) {
            setDropdown(false);
        }
    }, [isMobile, setDropdown]);



    /* ---------------- Outside click ---------------- */

    const handleClick = useCallback((e) => {
        const target = e.target;
        if (!(target instanceof HTMLElement)) return;

        const clickedOutsideMenu = !(menuRef.current && menuRef.current.contains(target));
        const clickedOutsideMobNav = !(mobHeaderRef.current && mobHeaderRef.current.contains(target));

        if (clickedOutsideMenu && clickedOutsideMobNav) {
            setDropdown(false)
            setPzMenu(0)
        }

    }, [setDropdown]);


    useEffect(() => {
        if (!mobileMenu && pzMenu === 0) return;

        document.addEventListener("pointerdown", handleClick);
        return () => {
            document.removeEventListener("pointerdown", handleClick);
        };
    }, [handleClick, mobileMenu, pzMenu]);


    /* ---------------- Burger click ---------------- */

    const handleBurgerClick = useCallback(() => {
        if (pzMenu > 0) {
            setPzMenu(0);
        } else {
            setDropdown(!mobileMenu);
        }
    }, [pzMenu, mobileMenu, setDropdown]);

    const globHeadersClass = isMobile ?
        'mobile_menu d-flex justify-content-between justify-content-md-end align-items-center mr-3' :
        (' col-12 col-md-9 d-none d-md-flex justify-content-end align-items-center pt-sm-92 pb-sm-20' + (mobileMenu ? ' visible-mobile' : ' visible-desktop'))

    const headerNavBarClass = 'col-12 col-md-9 d-none d-md-flex flex-sm-column align-items-center flex-wrap pt-sm-92 pb-sm-20' + (mobileMenu ? ' visible-mobile' : ' visible-desktop')

    return <>
        <div ref={menuRef} className={globHeadersClass} id="menu">
            <GlobHeaders
                isMobile={isMobile}
                auth={auth}
                pzMenu={pzMenu}
                setPzMenu={setPzMenu}
                setDropdown={setDropdown}
                burgerActive={mobileMenu || pzMenu > 0}
                handleBurgerClick={handleBurgerClick}
            />
        </div>
        {isMobile ? <div ref={mobHeaderRef} className={headerNavBarClass}>
            <HeaderNavBar />
        </div> : null}
    </>
}

export default HeaderAccountMenu;